/* eslint-disable no-case-declarations */
import * as Types from 'domain/stockUnit/actionTypes';

const initialState = {
  stockUnits: [],
};

const stockUnitReducer = function (state = initialState, action) {
  const { type, payload } = action;

  switch (type) {
    case Types.INIT:
      const newStockUnits = payload.stockUnits;
      return { ...state, stockUnits: newStockUnits };
    default:
      return state;
  }
};

export default stockUnitReducer;
